import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, officerOnly = false, cms = null }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-sapphire-deep">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-gold border-t-transparent" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !user.is_admin) return <Navigate to="/portal" replace />;
  if (officerOnly && !user.is_officer) return <Navigate to="/portal" replace />;
  if (cms === "staff" && !(user.cms?.author || user.cms?.reviewer)) return <Navigate to="/portal" replace />;
  if (cms === "admin" && !user.cms?.admin) return <Navigate to="/portal" replace />;

  return children;
}
